// Caps the *displayed* product rating. The underlying review data stays truthful;
// this only limits what we show, so a perfect run of 5-star reviews presents as a
// more credible 4.8 rather than a flat 5.0. Applied consistently to the reviews
// summary, the price-area rating, and the Product structured data so the visible
// rating and the rich-snippet rating never disagree.
export const MAX_DISPLAY_RATING = 4.8

export const capDisplayRating = (rating: number): number => (
    Number.isFinite(rating) ? Math.min(rating, MAX_DISPLAY_RATING) : rating
)
